// Lucide icon: bed (https://lucide.dev/icons/bed)
import { Bed } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconHotel = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Bed />
    </IconComponentStyled>
  )
}
